// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Button, Columns, Text, Stack } from '@locus-taxy/neo-ui';

import type { Labels } from './types';

type Props = {
    labels: Labels,
    onAdd: () => void,
    onDismiss: () => void,
    totalNoOfFields: number
};

const ModalHeader = ({
    labels,
    onAdd,
    onDismiss,
    totalNoOfFields
}: Props): React.Node => {
    const { t } = useTranslation('platform');

    return (
        <Flex
            alignItems="center"
            backgroundColor="white"
            px={6}
            py={4}
            justifyContent="space-between"
        >
            <Columns space="small" alignY="center">
                <Button
                    appearance="solid"
                    palette="primary"
                    icon="arrow_left"
                    shape="round"
                    onClick={onDismiss}
                />

                <Stack space="xxSmall">
                    <Text size="large">{labels.headerText}</Text>
                    <Text size="intermediate">
                        {totalNoOfFields} {t('translations:total')}
                    </Text>
                </Stack>
            </Columns>

            <Button
                appearance="solid"
                palette="primary"
                icon="add"
                onClick={onAdd}
            >
                {labels.actionText}
            </Button>
        </Flex>
    );
};

export default ModalHeader;
